<!-- Copy Order Popup -->
<div class="ModernPopupOverlay" *ngIf="ShowOrderCopy" (click)="ShowOrderCopy = false; CurrentOrder = null;">
  <div class="ModernPopup small" (click)="$event.stopPropagation()">
    <div class="ModernPopupHeader">
      <div class="ModernPopupTitle">
        <i class="material-icons" style="color: #667eea;">content_copy</i>
        <span>{{ 'CopyOfferRequestTitle' | translate }}</span>
      </div>
      <button class="ModernPopupClose" (click)="ShowOrderCopy = false; CurrentOrder = null;">
        <i class="material-icons">close</i>
      </button>
    </div>
    <div class="ModernPopupBody">
      <p class="ModernPopupDescription" style="text-align: center;">{{ 'CopyOfferRequestDescription' | translate }}</p>
    </div>
    <div class="ModernPopupFooter">
      <button class="ModernButton outline" [disabled]="this.parent.loading" (click)="ShowOrderCopy = false; CurrentOrder = null;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button class="ModernButton primary" [disabled]="this.parent.loading" (click)="ShowOrderCopy = false;CopyOrder(CurrentOrder);">
        <i class="material-icons">content_copy</i>
        <span>{{ 'AcceptAndContinueCopy' | translate }}</span>
      </button>
    </div>
  </div>
</div>

<!-- Cancel Order Popup -->
<div class="ModernPopupOverlay" *ngIf="ShowOrderCancelation" (click)="ShowOrderCancelation = false; CurrentOrder = null;">
  <div class="ModernPopup small" (click)="$event.stopPropagation()">
    <div class="ModernPopupHeader">
      <div class="ModernPopupTitle">
        <i class="material-icons" style="color: #fd4f57;">warning</i>
        <span>{{ 'CancelQuestion' | translate }}</span>
      </div>
      <button class="ModernPopupClose" (click)="ShowOrderCancelation = false; CurrentOrder = null;">
        <i class="material-icons">close</i>
      </button>
    </div>
    <div class="ModernPopupBody">
      <p class="ModernPopupDescription" style="text-align: center;">{{ 'CancelQuestionDescription' | translate }}</p>
    </div>
    <div class="ModernPopupFooter">
      <button class="ModernButton outline" [disabled]="this.parent.loading" (click)="ShowOrderCancelation = false; CurrentOrder = null;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button class="ModernButton danger" [disabled]="this.parent.loading" (click)="ShowOrderCancelation = false;CancelOrder(CurrentOrder);">
        <i class="material-icons">close</i>
        <span>{{ 'YesCancel' | translate }}</span>
      </button>
    </div>
  </div>
</div>

<div class="overlay" *ngIf="ShowEditContainer;"></div>

<div class="EditContainer animated fadeInDown" *ngIf="this.ShowEditContainer == true;">
    <div class="EditContainerCloseButton" (click)="this.ShowEditContainer = false;">
        <i class="material-icons">close</i>
    </div>
    <div class="EditContainerHeadder">
      <p class="EditContainerHeadderTitle">
        <span class="EditContainerReferenceNumber">{{CurrentOrder.ReferenceNumber}}</span>
        <span class="EditContainerDebatorPO" *ngIf="CurrentOrder?.DebatorPO?.length > 0;">{{CurrentOrder.DebatorPO}}</span>
      </p>
    </div>
    <div class="EditContainerBody">

      <div class="EditContainerBodyStatus unSelectable">
        <span class="EditContainerBodyStatusTitle">Status: </span>
        <span class="OrdersRowColInfoStatusSpan" [ngClass]="{'NewOrderStatus': CurrentOrder.OfferRequestStatus.ID == 0, 'ProcessingOrderStatus': CurrentOrder.OfferRequestStatus.ID == 1,'PartiallyConfirmedOrderStatus': CurrentOrder.OfferRequestStatus.ID == 9,'ConfirmedOrderStatus': CurrentOrder.OfferRequestStatus.ID == 10, 'CanceledOrderStatus': CurrentOrder.OfferRequestStatus.ID == 11}">{{CurrentOrder.OfferRequestStatus.Name}}</span>
      </div>

      <div class="EditContainerBodySection">
        <div class="EditContainerBodySectionTitle unSelectable">
          <i class="material-icons">info</i>
          <span>{{'GeneralInfomration' | translate}}</span>
          <i class="material-icons OpenSectionArrow" (click)="this.ShowOrderGeneralInformation = true;" *ngIf="this.ShowOrderGeneralInformation == false;">keyboard_arrow_right</i>
          <i class="material-icons OpenSectionArrow" (click)="this.ShowOrderGeneralInformation = false;" *ngIf="this.ShowOrderGeneralInformation == true;">keyboard_arrow_down</i>
        </div>
  
        <div class="DottedSectionButton" *ngIf="this.ShowOrderGeneralInformation == false;" (click)="this.ShowOrderGeneralInformation = true;">
          <span>...</span>
        </div>
  
        <div *ngIf="this.ShowOrderGeneralInformation == true;">
          <div class="EditContainerBodyTextBoxContainer">
            <div class="TextBoxTitle">{{'RequestNumber' | translate}}</div> 
            <div class="CentralTextBoxContainer">
            <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'RequestNumber' | translate}}" [(ngModel)]="this.CurrentOrder.ReferenceNumber" matInput>
            </div>
          </div>
    
            <div class="EditContainerBodyTextBoxContainer">
              <div class="TextBoxTitle">{{'DebatorPO' | translate}}</div> 
              <div class="CentralTextBoxContainer">
              <input style="letter-spacing: 2px;font-weight: 500;color: #f60;" type="text" class="TextBoxContainer" placeholder="{{'DebatorPO' | translate}}" [(ngModel)]="this.CurrentOrder.DebatorPO" matInput>
              </div>
            </div>
    
            <div class="EditContainerBodyTextBoxContainer">
              <div class="TextBoxTitle">{{'Uploader' | translate}}</div> 
              <div class="CentralTextBoxContainer">
              <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'UserUploader' | translate}}" [(ngModel)]="this.CurrentOrder.UserUploader.UIName" matInput>
              </div>
            </div>
    
            <div class="EditContainerBodyTextBoxContainer">
              <div class="TextBoxTitle">{{'Manager' | translate}}</div> 
              <div class="CentralTextBoxContainer">
              <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'UserUploader' | translate}}" [(ngModel)]="this.CurrentOrder.UserManager.UIName" matInput>
              </div>
            </div>
  
            <div class="CartSummary unSelectable CartSummarySmaller">
              <div class="CartSummaryTitle">
                <p>{{'OrderContactAgents' | translate}}</p>
              </div>
            
              <div class="PartnerAgentRow" *ngFor="let agent of this.CurrentOrder.Cart.Partner?.PartnerAgents" [ngClass]="{ 'UnSelectedAgent': agent.IsSelected != true}" (click)="agent.IsSelected = !agent.IsSelected;">
                <p>{{agent.Email}}</p>
                <i class="material-icons" *ngIf="agent.IsSelected == true;" style="color: #32aa3a;">check</i>
                <i class="material-icons" *ngIf="agent.IsSelected != true;" style="color: #fd4f57;">close</i>
              </div>
            </div>
        </div>
      </div>

        <div class="EditContainerBodySection">
          <div class="EditContainerBodySectionTitle unSelectable">
            <i class="material-icons">insert_drive_file</i>
            <span>{{'BillingInformation' | translate}}</span>
            <i class="material-icons OpenSectionArrow" (click)="this.ShowOrderBillingInformation = true;" *ngIf="this.ShowOrderBillingInformation == false;">keyboard_arrow_right</i>
            <i class="material-icons OpenSectionArrow" (click)="this.ShowOrderBillingInformation = false;" *ngIf="this.ShowOrderBillingInformation == true;">keyboard_arrow_down</i>
          </div>
  
          <div class="DottedSectionButton" *ngIf="this.ShowOrderBillingInformation == false;" (click)="this.ShowOrderBillingInformation = true;">
            <span>...</span>
          </div>
  
         <div *ngIf="this.ShowOrderBillingInformation == true;">
          <div class="EditContainerBodyTextBoxContainer">
            <div class="TextBoxTitle">{{'Name' | translate}}</div> 
            <div class="CentralTextBoxContainer">
            <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'Name' | translate}}" [(ngModel)]="this.CurrentOrder.Cart.Partner.Name" matInput>
            </div>
          </div>

          <div class="EditContainerBodyTextBoxContainer">
            <div class="TextBoxTitle">{{'VAT' | translate}}</div> 
            <div class="CentralTextBoxContainer">
            <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'VAT' | translate}}" [(ngModel)]="this.CurrentOrder.Cart.Partner.VAT" matInput>
            </div>
          </div>

          <div class="EditContainerBodyTextBoxContainer">
            <div class="TextBoxTitle">{{'COCRegNumber' | translate}}</div> 
            <div class="CentralTextBoxContainer">
            <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'COCRegNumber' | translate}}" [(ngModel)]="this.CurrentOrder.Cart.Partner.COCRegNumber" matInput>
            </div>
          </div>

          <div class="EditContainerBodyTextBoxContainer">
            <div class="TextBoxTitle">{{'Country' | translate}}</div> 
            <div class="CentralTextBoxContainer">
            <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'Country' | translate}}" [(ngModel)]="this.CurrentOrder.Cart.Partner.BillingAddress.Country.Name" matInput>
            </div>
          </div>
  
          <div class="EditContainerBodyTextBoxContainer">
            <div class="TextBoxTitle">{{'StateProvince' | translate}}</div> 
            <div class="CentralTextBoxContainer">
            <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'StateProvince' | translate}}" [(ngModel)]="this.CurrentOrder.Cart.Partner.BillingAddress.StateProvince" matInput>
            </div>
          </div>
  
          <div class="EditContainerBodyTextBoxContainer">
            <div class="TextBoxTitle">{{'City' | translate}}</div> 
            <div class="CentralTextBoxContainer">
            <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'City' | translate}}" [(ngModel)]="this.CurrentOrder.Cart.Partner.BillingAddress.City" matInput>
            </div>
          </div>
  
          <div class="EditContainerBodyTextBoxContainer">
            <div class="TextBoxTitle">{{'AddressLine' | translate}}</div> 
            <div class="CentralTextBoxContainer">
            <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'AddressLine' | translate}}" [(ngModel)]="this.CurrentOrder.Cart.Partner.BillingAddress.AddressLine" matInput>
            </div>
          </div>
         </div>
        </div>

        <div class="EditContainerBodySection">
          <div class="EditContainerBodySectionTitle unSelectable">
            <i class="material-icons">airplanemode_on</i>
            <span>{{'ShippingAddresses' | translate}}</span>
            <i class="material-icons OpenSectionArrow" (click)="this.ShowOrderShippingInformation = true;" *ngIf="this.ShowOrderShippingInformation == false;">keyboard_arrow_right</i>
            <i class="material-icons OpenSectionArrow" (click)="this.ShowOrderShippingInformation = false;" *ngIf="this.ShowOrderShippingInformation == true;">keyboard_arrow_down</i>
          </div>
  
          <div class="DottedSectionButton" *ngIf="this.ShowOrderShippingInformation == false;" (click)="this.ShowOrderShippingInformation = true;">
            <span>...</span>
          </div>
  
           <div *ngIf="this.ShowOrderShippingInformation == true;">
            <mat-form-field appearance="outline"class="EditContainerBodyDropDown" *ngIf="this.CurrentOrder.Cart.Partner.ShippingAddresses?.length > 0">
              <mat-label>{{ 'ShippingAddresses' | translate }}</mat-label>
              <mat-select name="ShippingAddresses" [compareWith]="this.parent.compareFn" [(ngModel)]="this.CurrentOrder.ShippingAddress" style="height: 30px;padding-top: 7px;">
                <mat-option *ngFor="let a of this.CurrentOrder.Cart.Partner.ShippingAddresses" [value]="a">
                  {{a.Country.Name}} {{a.City}} {{a.AddressLine}}
                </mat-option>
              </mat-select>
            </mat-form-field>
  
          <mat-form-field appearance="outline" class="EditContainerBodyDropDown">
            <mat-label>{{ 'Country' | translate }}</mat-label>
            <mat-select disabled="true" name="ShippingAddresses" [compareWith]="this.parent.compareFn" [(ngModel)]="this.CurrentOrder.ShippingAddress.Country" style="height: 30px;padding-top: 7px;">
              <mat-option *ngFor="let c of this.parent.masterData.Countries" [value]="c">
                {{c.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
  
          <div class="EditContainerBodyTextBoxContainer">
            <div class="TextBoxTitle">{{'StateProvince' | translate}}</div> 
            <div class="CentralTextBoxContainer">
            <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'StateProvince' | translate}}" [(ngModel)]="this.CurrentOrder.ShippingAddress.State" matInput>
          </div>
          </div>
  
          <div class="EditContainerBodyTextBoxContainer">
          <div class="TextBoxTitle">{{'Partners.PartnerWindow.City' | translate}}</div> 
          <div class="CentralTextBoxContainer">
          <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'Partners.PartnerWindow.City' | translate}}" [(ngModel)]="this.CurrentOrder.ShippingAddress.City" matInput>
          </div>
          </div>
  
          <div class="EditContainerBodyTextBoxContainer">
          <div class="TextBoxTitle">{{'Partners.PartnerWindow.AddressLine' | translate}}</div> 
          <div class="CentralTextBoxContainer">
          <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'Partners.PartnerWindow.AddressLine' | translate}}" [(ngModel)]="this.CurrentOrder.ShippingAddress.AddressLine" matInput>
          </div>
          </div>
  
          <div class="EditContainerBodyTextBoxContainer">
          <div class="TextBoxTitle">{{'ZipCode' | translate}}</div> 
          <div class="CentralTextBoxContainer">
          <input disabled="true" style="letter-spacing: 2px;font-weight: 500;" type="text" class="TextBoxContainer" placeholder="{{'ZipCode' | translate}}" [(ngModel)]="this.CurrentOrder.ShippingAddress.ZipCode" matInput>
          </div>
          </div>
           </div>
        </div>

        <div class="EditContainerBodySection">
          <div class="EditContainerBodySectionTitle unSelectable">
            <i class="material-icons">shopping_cart</i>
            <span>{{'Products' | translate}}</span>
            <i class="material-icons OpenSectionArrow" (click)="this.ShowOrderProductsInformation = true;" *ngIf="this.ShowOrderProductsInformation == false;">keyboard_arrow_right</i>
            <i class="material-icons OpenSectionArrow" (click)="this.ShowOrderProductsInformation = false;" *ngIf="this.ShowOrderProductsInformation == true;">keyboard_arrow_down</i>
          </div>

          <div class="DottedSectionButton" *ngIf="this.ShowOrderProductsInformation == false;" (click)="this.ShowOrderProductsInformation = true;">
            <span>...</span>
          </div>

          <div *ngIf="this.ShowOrderProductsInformation == true;">
            <div class="GridContainer" (keydown)="this.parent.handleKeyDown($event)">
              <div class="GridRow">
                <div class="GridCol GridHeadderCol unSelectable" style="width: Calc(5% - 2px);">
                  #
                </div>
            
                <div class="GridCol GridHeadderCol unSelectable leftText" style="width: Calc(15% - 2px);">
                  {{'Brand' | translate}}
                </div>
            
              <div class="GridCol GridHeadderCol unSelectable leftText" style="width: Calc(45% - 2px);" matTooltip="{{ 'ProductNamePartNumberDescription' | translate}}" matTooltipClass='neutral-tool-tip'>
                 {{'ProductNamePartNumber' | translate}}
              </div>
            
              <div class="GridCol GridHeadderCol unSelectable" style="width: Calc(5% - 2px);">
                {{'Quantity' | translate}}
              </div>
            
              <div class="GridCol GridHeadderCol unSelectable" style="width: Calc(10% - 2px);">
                {{'Price' | translate}}
              </div>
            
              <div class="GridCol GridHeadderCol unSelectable" style="width: Calc(10% - 2px);">
                {{'Total' | translate}}
              </div>
            
              <div class="GridCol GridHeadderCol unSelectable" style="width: Calc(10% - 2px);">
                {{'ETA' | translate}}
              </div>
              </div>
            
              <div class="GridRow" *ngFor="let item of this.CurrentOrder.Cart?.Items; let i = index;">
                <div class="GridCol" style="width: Calc(5% - 2px);" [ngClass]="{'SelectedOfferRow': item?.IsSelected == true}">
                  {{i + 1}}
                </div>
            
                <div class="GridCol leftText" style="width: Calc(15% - 2px);  cursor: pointer;" [ngClass]="{'SelectedOfferRow': item?.IsSelected == true}" (click)="this.parent.InitializeSearchProduct(item);">
                  <span *ngIf="item?.CartItemStatus?.ID >= 0;">{{item?.Product?.Brand?.Name}}</span>
                  <span *ngIf="item?.CartItemStatus?.ID == -1;"></span>
                  <span *ngIf="item?.CartItemStatus?.ID == -2 && item?.UIProductValue?.length > 0 && item?.WasSearchedFor == true && item.UserSelectedBrand == null;">
                  </span>
                  <span *ngIf="item?.CartItemStatus?.ID == -2 && item?.UIProductValue?.length > 0 && item?.WasSearchedFor == true && item.UserSelectedBrand != null;">
                    {{item?.UserSelectedBrand?.Name}}
                  </span>
            
                  <div *ngIf="item.ShowBrandSearchResults == true;" class="GridBrandSearchResults">
                    <div class="GridBrandSearchResultsTopSearch">
                      <input type="text" placeholder="ex: SIEMENS" [(ngModel)]="this.parent.brandSearch" class="GridBrandSearchInput" matInput (ngModelChange)="this.parent.GetBrandsFilteredWithSuggestion(this.parent.brandSearch);"/>
                    </div>
                    <div class="GridBrandSearchResultsBody" *ngIf="this.parent.BrandsLoading != true;">
                      <div class="GridBrandSearchRow" *ngFor="let brand of this.parent.Brands; let b = index;" (click)="this.parent.SelectItemBrand(item, brand);">
                        <span>{{brand.Name}}</span>
                      </div>
                    </div>
                    <mat-spinner *ngIf="this.parent.BrandsLoading == true;" diameter="25" class="BrandsLoadingSpinner"></mat-spinner>
                  </div>
                </div>
            
                <div class="GridCol leftText" style="width: Calc(45% - 2px); background: #fff;padding-left: 0!important; cursor: pointer;" [ngClass]="{'awaitingChoiceMarkedRows': item?.CartItemStatus?.ID == -1, 'notFoundMarkedRows': item?.CartItemStatus?.ID == -2 && item?.WasSearchedFor == true, 'validMarkedRows': item?.CartItemStatus?.ID == 1, 'invalidMarkedRows': item?.CartItemStatus?.ID == 0}">
                  <textarea disabled="true" *ngIf="item.LoadingCell != true;" class="GridColFullText" type="text" (click)="this.parent.InitializeSearchProduct(item);" [(ngModel)]="item.UIProductValue" matInput (ngModelChange)="this.parent.searchTermUpdate.next($event)"></textarea>
                  <input disabled="true" *ngIf="item.LoadingCell == true;" class="GridColFullText" type="text" matInput (ngModelChange)="this.parent.OnlyNumbers($event)"/>
                  <i class="material-icons cellCheckIcon" *ngIf="item?.CartItemStatus?.ID == 1;">check</i>
                  <mat-spinner *ngIf="item.LoadingCell == true;" diameter="25" class="CellSpinner"></mat-spinner>
                  <div *ngIf="item.ShowSearchResults == true && item?.SearchResults?.length > 0;" class="itemChoiceContainer">
                    <div *ngFor="let s of this.item.SearchResults; let j = index;" class="cellSearchResultRow" (click)="this.parent.SelectGridSearchResult(s, item);" [ngClass]="{'SelectedOfferRow': s.IsSelected == true}">
                      <span>{{s.FKBrandName}}</span>  
                      <span>{{s.ProductName}}</span> <span *ngIf="s.ProductPartNumber?.length > 0;">(PN: {{s.ProductPartNumber}})</span>
                      <i class="material-icons SelectedGridSearchResult" *ngIf="s.IsSelected == true;">check</i>
                    </div>
                  </div>
                </div>
            
                <div class="GridCol" style="width: Calc(5% - 2px); background: #fff;" [ngClass]="{'SelectedOfferRow': item?.IsSelected == true}">
                  <div class="MOQSign" *ngIf="item?.SelectedOffer?.ChangedQunatityFromMOQ == true" matTooltip="{{'MOQDesc' | translate}} {{item.SelectedOffer.MOQ}}" matTooltipClass='neutral-tool-tip'></div>
                  <input disabled="true" class="GridColFullText" type="text" [(ngModel)]="item.Quantity" matInput *ngIf="item.Quantity > 0" (ngModelChange)="this.parent.OnlyNumbers($event)" (change)="this.parent.ChangeGridCellItem(item);"/>
                </div>
            
                <div class="GridCol" style="width: Calc(10% - 2px);" [ngClass]="{'SelectedOfferRow': item?.IsSelected == true}">
                  {{item.Price?.UIUnitPrice}} {{item.Price?.Currency?.Symbol}}
                </div>
            
                <div class="GridCol" style="width: Calc(10% - 2px);" [ngClass]="{'SelectedOfferRow': item?.IsSelected == true}">
                  {{item.Price?.UIQtyPrice}} {{item.Price?.Currency?.Symbol}}
                </div>
            
              <div class="GridCol" style="width: Calc(10% - 2px);" [ngClass]="{'SelectedOfferRow': item?.IsSelected == true}">
                <span class="DottStatus" *ngIf="item.RequestDeliveryStatus?.ID == -1" style="background: #f60;" matTooltip="{{item.RequestDeliveryStatus?.Name}}" matTooltipClass='neutral-tool-tip'></span>
                <span class="DottStatus" *ngIf="item.RequestDeliveryStatus?.ID == 0" style="background: #32aa3a;" matTooltip="{{item.RequestDeliveryStatus?.Name}}" matTooltipClass='neutral-tool-tip'></span>
                <span class="DottStatus" *ngIf="item.RequestDeliveryStatus?.ID == 1" matTooltip="{{item.RequestDeliveryStatus?.Name}}" matTooltipClass='neutral-tool-tip'></span>
                <span *ngIf="item.SelectedOffer?.LeadTime != null;">{{item.SelectedOffer?.LeadTime?.Units}} {{item.SelectedOffer?.LeadTime?.Type?.Name}}</span>
                <span *ngIf="item.SelectedOffer?.LeadTime == null;">------</span>
              </div>
              </div>
            </div>
          </div>
        </div>

    </div>

    <div class="EditContainerControlls">
      <button class="GridCommandButton GridCommandButtonBlue">
        <i class="material-icons">save_alt</i>
        <span>{{'Save' | translate}}</span>
      </button>

      <!-- <button class="GridCommandButton" style="float: right; margin-right: 2.5%;">
        <i class="material-icons">content_copy</i>
        <span>{{'Copy' | translate}}</span>
      </button> -->
    </div>
</div>

<div class="MainOrdersContainer">
  <div class="OrderControlls">
    <div class="MainTitleBar">
      <div class="CompanyContainer">
        <mat-form-field style="width: 100%;" appearance="outline">
          <mat-label>{{ 'Company' | translate }}</mat-label>
          <mat-select name="Company" [compareWith]="this.parent.compareFn" [(ngModel)]="this.Filter.Company">
            <mat-option *ngFor="let c of this.Companies" [value]="c" (click)="GetInvoicesFiltered();">
              {{c.Name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="MainTitleBar" style="overflow: hidden;">
        <div class="FifteenPercentContainer">
          <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
            <mat-label>{{ 'Receptions.ChoosePeriod' | translate }}</mat-label>
            <mat-select name="Administration" [(ngModel)]="Filter.Period">
              <mat-option *ngFor="let a of this.Periods;" [value]="a" (click)="AddActiveFilter(a.Name, 'Period'); GetOrdersFiltered();">
                {{a.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="FifteenPercentContainer">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Receptions.FromDate' | translate }}</mat-label>
            <input matInput [matDatepicker]="dp" [formControl]="FromDate" [(ngModel)]="Filter.FromDate" (dateChange)="ClearPeriod()">
            <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
            <mat-datepicker #dp></mat-datepicker>
          </mat-form-field>
        </div>
      
        <div class="FifteenPercentContainer">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Receptions.ToDate' | translate }}</mat-label>
            <input matInput [matDatepicker]="dp1" [formControl]="ToDate" [(ngModel)]="Filter.ToDate" (click)="DisablePeriod();" (dateChange)="ClearPeriod()">
            <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
            <mat-datepicker #dp1></mat-datepicker>
          </mat-form-field>
        </div>
      
        <button class="GridCommandButton" (click)="GetInvoicesFiltered();">
          <i class="material-icons">filter_alt</i>
          <span>{{ 'Filter' | translate }}</span>
        </button>
      
    </div>

    <div class="MainTitleBar" style="overflow: unset;">

      <div class="ActiveFiltersContainer">
        <div class="ActiveFilter" *ngFor="let a of this.activeFilters;" (click)="RemoveActiveFilter(a.ID, a.Type);">
          {{a.Name}}
          <i class="material-icons">close</i>
        </div>
      </div>
    </div>

    <div class="MainTitleBar" style="overflow: unset;">
      <!-- Left: Product Search (Google Style) -->
      <div class="MainOrdersSearchContainer">
        <input type="text" class="MainOrdersSearch" placeholder="{{'SearchByProduct' | translate}}" [(ngModel)]="ProductSearchTerm" (ngModelChange)="this.productSearchTermUpdate.next($event)">
        <i class="material-icons" *ngIf="!(ProductSearchTerm?.length > 0);">search</i>
        <i class="material-icons" *ngIf="(ProductSearchTerm?.length > 0);" (click)="this.ProductSearchTerm = ''; this.Filter.Product = ''; GetInvoicesFiltered(1);">close</i>
      </div>

      <!-- Right Side: Pagination Info & Controls -->
      <div class="RightPagination">

        <div class="PaginationControls">
          <button class="GridCommandButton PaginationButton" [disabled]="this.Filter.Pager.PageIndex == 1" (click)="GetInvoicesFiltered(1);">
            <i class="material-icons">first_page</i>
          </button>
          <button class="GridCommandButton PaginationButton" [disabled]="this.Filter.Pager.PageIndex == 1" (click)="GetInvoicesFiltered(this.Filter.Pager.PageIndex - 1);">
            <i class="material-icons">chevron_left</i>
          </button>

          <div class="PageNumberDisplay">
            <span class="CurrentPage">{{this.Filter.Pager.PageIndex}}</span>
            <span class="PageSeparator">/</span>
            <span class="TotalPages">{{this.Filter.Pager.Pages}}</span>
          </div>

          <button class="GridCommandButton PaginationButton" [disabled]="this.Filter.Pager.PageIndex == this.Filter.Pager.Pages" (click)="GetInvoicesFiltered(this.Filter.Pager.PageIndex + 1);">
            <i class="material-icons">chevron_right</i>
          </button>
          <button class="GridCommandButton PaginationButton" [disabled]="this.Filter.Pager.PageIndex == this.Filter.Pager.Pages" (click)="GetInvoicesFiltered(this.Filter.Pager.Pages);">
            <i class="material-icons">last_page</i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="OrdersTable">
    <div class="OrdersHeadder unSelectable">
        <div class="InvoiceHeaderSection InvoiceHeaderNumber">
            <span>{{'#' | translate}}</span>
        </div>

        <div class="InvoiceHeaderSection InvoiceHeaderClient">
            <span>{{'Client' | translate}}</span>
        </div>

        <div class="InvoiceHeaderSection InvoiceHeaderDate">
            <span>{{'Date' | translate}}</span>
        </div>

        <div class="InvoiceHeaderSection InvoiceHeaderTotal">
            <span>{{'Total' | translate}}</span>
        </div>

        <div class="InvoiceHeaderSection InvoiceHeaderActions">
            <span>{{'Actions' | translate}}</span>
        </div>
    </div>

    <div class="OrdersBody" *ngIf="this.parent.loading == true;">
        <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
    </div>

    <div class="OrdersBody" *ngIf="this.parent.loading != true;">
        <ng-container *ngFor="let i of this.Invoices;">
            <div class="InvoiceCardWrapper">
                <div class="InvoiceCardRow">
                    <!-- Invoice Number -->
                    <div class="InvoiceRowSection InvoiceRowNumber">
                        <i class="material-icons">receipt</i>
                        <div class="InvoiceRowContent">
                            <span class="InvoiceRowLabel">{{'InvoiceNumber' | translate}}</span>
                            <span class="InvoiceRowValue InvoiceNumber">{{i.AccountingNumber.DisplayValue}}</span>
                        </div>
                    </div>

                    <!-- Client -->
                    <div class="InvoiceRowSection InvoiceRowClient">
                        <i class="material-icons">business</i>
                        <div class="InvoiceRowContent">
                            <span class="InvoiceRowLabel">{{'Client' | translate}}</span>
                            <span class="InvoiceRowValue ClientName">{{i.Client.Name}}</span>
                        </div>
                    </div>

                    <!-- Date -->
                    <div class="InvoiceRowSection">
                        <i class="material-icons">event</i>
                        <div class="InvoiceRowContent">
                            <span class="InvoiceRowLabel">{{'Date' | translate}}</span>
                            <span class="InvoiceRowValue">{{i.EventRegisterUIDate}}</span>
                        </div>
                    </div>

                    <!-- Amount -->
                    <div class="InvoiceRowSection">
                        <div class="InvoiceRowContent">
                            <span class="InvoiceRowLabel">{{'Total' | translate}}</span>
                            <span class="InvoiceRowValue InvoiceRowValueBold">{{i.Total.UITotalQtyPriceVAT.Integer}}{{i.Total.UITotalQtyPriceVAT.Decimals}} {{i.Currency.Name}}</span>
                        </div>
                    </div>

                    <!-- Actions -->
                    <div class="InvoiceRowSection InvoiceRowActions">
                        <button class="GridCommandButton GridCommandButtonGreen" (click)="ExportInvoice(i);" matTooltip="{{'Download' | translate}}" matTooltipClass='neutral-tool-tip'>
                            <i class="material-icons">file_download</i>
                            <span>{{'Download' | translate}}</span>
                        </button>
                        <button class="GridCommandButton GridCommandButtonBlue" (click)="PrintInvoice(i);" matTooltip="{{'Print' | translate}}" matTooltipClass='neutral-tool-tip'>
                            <i class="material-icons">print</i>
                            <span>{{'Print' | translate}}</span>
                        </button>
                    </div>
                </div>

                <!-- Status Row Below -->
                <div class="InvoiceStatusRow">
                    <div class="InvoiceStatusGroup">
                        <span class="InvoiceStatusBadge" [ngClass]="{'CancelledStatus': i.DocumentStatus.ID == -1, 'CollectedStatus': i.DocumentStatus.ID == 1,'PartiallyCollected': i.DocumentStatus.ID == 2,'SurplusCollected': i.DocumentStatus.ID == 3, 'CreatedStatus': i.DocumentStatus.ID == 4, 'Overdue': i.DocumentStatus.ID == 5}">
                            {{i.DocumentStatus.Name}}
                        </span>
                        <!-- Track Shipment Button - Right after status -->
                        <button class="GridCommandButton GridCommandButtonOrange TrackShipmentButton"
                                *ngIf="i.Details?.ShippingDetails?.ShippingCompany?.TrackingUrl && !i.IsDocumentOld"
                                (click)="openTrackingUrl(i.Details.ShippingDetails.ShippingCompany.TrackingUrl)"
                                matTooltip="{{'TrackShipment' | translate}}"
                                matTooltipClass='neutral-tool-tip'>
                            <i class="material-icons">location_on</i>
                            <span>{{'TrackShipment' | translate}}</span>
                        </button>
                        <!-- Old Invoice Disclaimer -->
                        <span class="OldInvoiceDisclaimer" *ngIf="i.IsDocumentOld && i.Details?.ShippingDetails">
                            {{'OldInvoiceTrackingDisclaimer' | translate}}
                        </span>
                    </div>
                    <!-- Shipping Info Row -->
                    <div class="ShippingInfoRow" *ngIf="i.Details?.ShippingDetails">
                        <!-- Tracking Number -->
                        <span class="ShippingInfoItem" *ngIf="i.Details.ShippingDetails.TrackingLabel">
                            <span class="ShippingInfoLabel">{{'TrackingNumber' | translate}}:</span>
                            <span class="ShippingInfoValue">{{i.Details.ShippingDetails.TrackingLabel}}</span>
                        </span>
                        <!-- Carrier Name -->
                        <span class="ShippingInfoItem" *ngIf="i.Details.ShippingDetails.ShippingCompany?.Name">
                            <span class="ShippingInfoLabel">{{'Carrier' | translate}}:</span>
                            <span class="ShippingInfoValue">{{i.Details.ShippingDetails.ShippingCompany.Name}}</span>
                        </span>
                        <!-- Shipping Status - Only for recent invoices -->
                        <span class="ShippingStatusBadge"
                              *ngIf="i.Details.ShippingDetails.CurrentTrackEvent && !i.IsDocumentOld"
                              [style.color]="i.Details.ShippingDetails.CurrentTrackEvent.Status?.Color?.Hash">
                            {{i.Details.ShippingDetails.CurrentTrackEvent.Status.Name}}
                        </span>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
  </div>
</div>
